import { SearchOptions } from "components/table/LargeTable";
import { createContext, useContext } from "react";

export const ToolbarContext = createContext<ToolbarFunctions>({filter: () => {}});

export type ToolbarFunctions = {
  setPage?: (pageNum: number, filter?: SearchOptions) => void
  reload?: (() => void)
  filter: () => void
  first?: (() => void)
  last?: (() => void)
  previous?: (() => void)
  next?: (() => void)
}

interface ToolbarProps {
  children: React.ReactNode
  toolbarFunctions: ToolbarFunctions
}

export const useToolbar = () => useContext(ToolbarContext)

const ToolbarProvider = ({children, toolbarFunctions}: ToolbarProps) =>
  <ToolbarContext.Provider value={toolbarFunctions}>
    {children}
  </ToolbarContext.Provider>
 
export default ToolbarProvider
